// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useState, useEffect, useRef, useMemo} from 'react';
import cn from 'classnames';
import etask from '/util/etask.js';
import {Icon} from '../icon';
import * as cns from './qr_code.module.less';

const PADDING = 16;

export function Qr_code({url, size=300, className}){
    const qr_ref = useRef();
    const [ready, set_ready] = useState(false);
    useEffect(()=>void etask(function*(){
        if (!qr_ref?.current || !url)
            return;
        const qrcode_lib = yield import('qrcode');
        const params = {
            width: size-PADDING*2,
            margin: 0
        };
        qrcode_lib.toCanvas(qr_ref.current, url, params, err=>{
            if (err)
                return void console.error(err);
            set_ready(true);
        });
    }), [url, size]);
    const style = useMemo(()=>{
        return {
            height: size,
            width: size,
        };
    }, [size]);
    return <div className={cn(cns.root, className)} style={style}>
      <canvas className={cns.canvas} ref={qr_ref}/>
      {!ready&&<Icon className={cns.spinner} ico="spinner" size="huge"/>}
    </div>;
}
